module.exports = __webpack_public_path__ + "0f46545044644a5dedb4922ffbc8d7f3.ttf";